function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.688.75H1.312C.588.75 0 1.338 0 2.063v7.874c0 .725.588 1.313 1.312 1.313h11.375c.725 0 1.313-.588 1.313-1.313V2.064C14 1.337 13.412.75 12.687.75zM12.1 3.795L7.823 7.216a1.313 1.313 0 01-1.646 0L1.9 3.795a.439.439 0 11.551-.682l4.279 3.42a.42.42 0 00.542 0l4.279-3.42a.446.446 0 01.621.06.455.455 0 01-.07.622z",
  fill: "#333",
  fillRule: "evenodd"
});

function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgEmail;